/* eslint-disable max-len */
import "react-responsive-modal/styles.css";

import React, { useEffect, useState } from 'react'
import Modal from "react-responsive-modal";
import RadioGroup from './RadioGroup'
import ErrorMessage from "../../../../components/ErrorMessage";
import Button from "../../../../components/Button";

const ModalBox = ({ 
    title, 
    options, 
    selectedValue, 
    open, 
    setmodalpopup, 
    setValue, 
    setNote, 
    note, 
    onUpdate, 
    isLoading, 
    noteError,
    staticStatus,
    onCloseFunction,
    setNoteError }) => {
    const [noteFocus, setNoteFocus] = useState(false);

    const textAreaHandler = (e) => {
        setNote(e.target.value);
    }

    const closeHandler = () => {
        setmodalpopup(prevState => {
            return { ...prevState, open: false }
        })
        setNote('');
        onCloseFunction();
        // setValue('');
    }

    return (
        <div className="modalBox">
            <Modal
                classNames={{
                    modal: 'customModal',
                }}
                open={open}
                onClose={closeHandler}
                closeIcon={<img src="/assets/images/close-icon.svg" loading='Lazy'
                    className='border-white focus:!border-0 focus:!outline-none !outline-none !border-0 mt-2 mr-1' 
                    alt="close" />}
                className="p-4 z-[100] w-fit"
            >
                <div className="changeStatusModal w-fit">
                    <h1 className="text-[#1F1F1F] text-lg font-medium mb-[10px]">
                        {title}
                    </h1>
                    <RadioGroup options={options} selectedValue={selectedValue} setValue={setValue}/>

                    <div className={`relative pl-[16px] py-[16px] mt-4 h-[120px] w-[352px] border 
                     ${noteError ? 'border-[#FC4523]' : 'border-[#DDD] mb-6'}`}>
                        <textarea 
                            id="note"
                            data-testid="note"
                            onFocusCapture={() => setNoteFocus(true)}
                            onBlurCapture={() => setNoteFocus(false)}
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            onFocus={() => setNoteError('')}
                            className={`h-[90px] caret-[#9e2063ab] text-justify mt-1 w-[278px] resize-none 
                            focus:outline-none focus:border-0 text-[14px] font-semibold leading-[22px] overflow-y-auto sidebar
                            ${noteError ? 'text-[#FC4523]' :'text-[#1F1F1F]'}`}
                        />
                        <label htmlFor="note"
                            className={`absolute mt-1 left-4 transition-all duration-300 
                            ${noteError ? 'text-[#FC4523]' : 'text-[#1F1F1F]'}  
                            ${note?.length > 0 || noteFocus ? '-translate-y-3.5 font-normal text-[12px] leading-[16px]' 
            :  'top-4 text-[14px] font-semibold leading-[22px]' } `}>
                            Note
                        </label>
                        <p className={`absolute bottom-0 right-0 p-2 font-semibold text-[14px] leading-[22px] 
                        ${noteError ? 'text-[#FC4523]' :'text-[#8E8E8E]'}`}>{note?.length || 0}/500</p>
                    </div>
                    {noteError && 
                    <ErrorMessage classKey='font-normal text-[12px] leading-[18px] text-[#FC4523] mt-1 mb-6' 
                        error={noteError} message={noteError} />}

                    <div className="flex justify-end gap-2">
                        <button className="text-[#9E2064] py-[10px] px-4 relative top-0 left-[-35%]" data-testid="cancel-btn"
                            onClick={closeHandler}>
                            Cancel
                        </button>
                        <Button 
                            classKey={`bg-[#9E2064] py-[10px] px-4 text-[#FFFFFF] whitespace-nowrap rounded-xl w-[125px] h-[44px] ${selectedValue === staticStatus && 'bg-opacity-30 '}
                                        disabled:cursor-not-allowed absolute`}
                            disabled={selectedValue === staticStatus}
                            testId="update-btn"
                            handleClick={onUpdate}
                            text='Change Status'
                            type='button'
                            loading={isLoading}
                        />
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default ModalBox